const ShowcaseCountersCard = ({
  agentsCount = 0,
  destinationsCount = 0,
  partnersCount = 0,
}) => {
  return (
    <div className="bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
      <div className="grid grid-cols-3 divide-x divide-slate-100">
        {/* Stat 1: Agents */}
        <div className="pr-2 sm:pr-3">
          <div className="text-lg sm:text-2xl lg:text-[22px] xl:text-[26px] font-normal text-primary tracking-tight leading-none">
            {agentsCount.toLocaleString()}+
          </div>
          <div className="text-[10px] sm:text-xs text-slate-500 mt-1 sm:mt-1.5 font-normal leading-tight">
            agents on Trrip
          </div>
        </div>

        {/* Stat 2: Destinations */}
        <div className="px-2 sm:px-3">
          <div className="text-lg sm:text-2xl lg:text-[22px] xl:text-[26px] font-normal text-primary tracking-tight leading-none">
            {destinationsCount.toLocaleString()}+
          </div>
          <div className="text-[10px] sm:text-xs text-slate-500 mt-1 sm:mt-1.5 font-normal leading-tight">
            destinations covered
          </div>
        </div>

        {/* Stat 3: Local Partners */}
        <div className="pl-2 sm:pl-3">
          <div className="text-lg sm:text-2xl lg:text-[22px] xl:text-[26px] font-normal text-primary tracking-tight leading-none">
            {partnersCount.toLocaleString()}+
          </div>
          <div className="text-[10px] sm:text-xs text-slate-500 mt-1 sm:mt-1.5 font-normal leading-tight">
            local partners
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowcaseCountersCard;
